/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Jobs_Variant_From_DateInputs */

const en_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variant from ${i?.date}`)
};

const de_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variante vom ${i?.date}`)
};

const fr_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variante du ${i?.date}`)
};

const es_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variante del ${i?.date}`)
};

const it_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variante del ${i?.date}`)
};

const nl_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variant van ${i?.date}`)
};

const pl_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wariant z ${i?.date}`)
};

const fi_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versio päivältä ${i?.date}`)
};

const da_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variant fra ${i?.date}`)
};

const sv_jobs_variant_from_date = /** @type {(inputs: Jobs_Variant_From_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variant från ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Variant from {date}" |
*
* @param {Jobs_Variant_From_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_variant_from_date = /** @type {((inputs: Jobs_Variant_From_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Variant_From_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_variant_from_date(inputs)
	if (locale === "fr") return fr_jobs_variant_from_date(inputs)
	if (locale === "es") return es_jobs_variant_from_date(inputs)
	if (locale === "it") return it_jobs_variant_from_date(inputs)
	if (locale === "nl") return nl_jobs_variant_from_date(inputs)
	if (locale === "pl") return pl_jobs_variant_from_date(inputs)
	if (locale === "fi") return fi_jobs_variant_from_date(inputs)
	if (locale === "da") return da_jobs_variant_from_date(inputs)
	if (locale === "sv") return sv_jobs_variant_from_date(inputs)
	return en_jobs_variant_from_date(inputs)
});